import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Card, CardBody, Col, Container, Form, Row } from "reactstrap";
import ModalLoding from "../../Components/Common/ModalLoading";

import * as Yup from "yup";

import BreadCrumb from "../../Components/Common/BreadCrumb";

import UiContent from "../../Components/Common/UiContent";
import { MANDATORY_FIELD } from "../../Components/constants/messages";
import {
  CoverUploadImageField,
  InputMask,
  TextField,
} from "../../Components/Forms";
import Loading from "../../Components/Loading/Loading";
import showNofity from "../../helpers/toast";
import { getCitiesRequest } from "../../store/city/actions";
import { getFiltersTouristSpotRequest } from "../../store/filters/touristSpot/actions";
import { createTouristSpotRequest } from "../../store/touristSpots/actions";
import { isLatitude, isLongitude } from "../../utils/formats";
import { forceNumericCoordinate } from "../../utils/coordinates";

const TouristSpotForm = () => {
  document.title = "Atrativo turístico | Ecoguias - Admin Dashboard";
  const dispatch = useDispatch();

  const { data: dataCity, loading: loadingCity } = useSelector(
    (state) => state.City
  );
  const { data: dataFilter, loadingFilter } = useSelector(
    (state) => state.FiltersTouristSpot
  );

  const { loading } = useSelector((state) => state.TouristSpots);

  const history = useHistory();

  useEffect(() => {
    dispatch(getCitiesRequest());
    dispatch(getFiltersTouristSpotRequest());
  }, [dispatch]);

  const touristSpot = useFormik({
    enableReinitialize: true,

    initialValues: {
      nome: "",
      descritivo: "",
      entre_contato: "",
      endereco: "",
      horario_funcionamento: "",
      email: "",
      cidade: "",
      telefone: "",
      images: [],
      latitude: "",
      longitude: "",
      imagem_principal: 0,
      filtro_ponto_turistico: "",
    },

    validationSchema: Yup.object({
      nome: Yup.string().required(MANDATORY_FIELD),
      descritivo: Yup.string().required(MANDATORY_FIELD),
      telefone: Yup.string(),
      entre_contato: Yup.string(),
      cidade: Yup.string().required(MANDATORY_FIELD),
      endereco: Yup.string(),
      horario_funcionamento: Yup.string(),
      email: Yup.string(),
      latitude: Yup.string()
        .nullable()
        .test("is-latitude", "Insira uma latitude válida", (value) =>
          value ? isLatitude(value) : true
        ),
      longitude: Yup.string()
        .nullable()
        .test("is-longitude", "Insira uma longitude válida", (value) =>
          value ? isLongitude(value) : true
        ),
      // .required(MANDATORY_FIELD),
      images: Yup.array(Yup.string()).required(MANDATORY_FIELD),
      filtro_ponto_turistico: Yup.string().required(MANDATORY_FIELD),
    }),
    onSubmit: async (values, { resetForm }) => {
      if (values.images.length < 1) {
        showNofity.error("Selecione uma imagem");
        return;
      }

      values.latitude = forceNumericCoordinate(values.latitude);
      values.longitude = forceNumericCoordinate(values.longitude);

      dispatch(createTouristSpotRequest({ values, resetForm }));
    },
  });

  return (
    <React.Fragment>
      <ToastContainer />
      <UiContent />
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Formulário de atrativo turístico"
            pageTitle="Atrativo turístico"
          />
        </Container>

        <Col lg={12}>
          <Card>
            <div className="p-4">
              <button
                className="btn btn-primary"
                onClick={() => history.goBack()}
              >
                Voltar
              </button>
            </div>

            <CardBody>
              <div className="live-preview">
                <Form
                  className="needs-validation"
                  onSubmit={(e) => {
                    e.preventDefault();
                    touristSpot.handleSubmit();
                    return false;
                  }}
                  action="#"
                >
                  <Row className="g-3">
                    <TextField label="Nome" name="nome" data={touristSpot} />

                    <TextField
                      type="select"
                      label="Filtro"
                      name="filtro_ponto_turistico"
                      data={touristSpot}
                      size={6}
                    >
                      <option value="" selected disabled>
                        Selecione o filtro
                      </option>
                      {dataFilter?.result?.length > 0 &&
                        dataFilter?.result?.map((item, idx) => (
                          <option key={idx} value={item.objectId}>
                            {item.nome}
                          </option>
                        ))}
                    </TextField>

                    <TextField
                      label="Horário de funcionamento"
                      name="horario_funcionamento"
                      data={touristSpot}
                    />

                    <InputMask
                      type="phone-br"
                      size={3}
                      label="Contato"
                      name="entre_contato"
                      data={touristSpot}
                    />

                    <InputMask
                      type="phone-br"
                      label="Whatsapp"
                      name="telefone"
                      data={touristSpot}
                      size={3}
                    />

                    <TextField
                      size={3}
                      label="E-mail"
                      name="email"
                      data={touristSpot}
                    />

                    <TextField
                      size={3}
                      label="Endereço"
                      name="endereco"
                      data={touristSpot}
                    />

                    <TextField
                      size={6}
                      label="Cidade"
                      name="cidade"
                      type="select"
                      data={touristSpot}
                    >
                      <option value="" disabled selected>
                        Selecione uma cidade
                      </option>
                      {dataCity?.result?.length > 0 &&
                        dataCity?.result.map((item, index) => (
                          <option key={index} value={item.objectId}>
                            {item.nome}
                          </option>
                        ))}
                    </TextField>

                    <TextField
                      size={3}
                      label="Latitude"
                      name="latitude"
                      data={touristSpot}
                      type="number"
                      onKeyDown={(event) => {
                        ["e", "E", "+", ","].includes(event.key) &&
                          event.preventDefault();
                      }}
                    />
                    <TextField
                      size={3}
                      label="Longitude"
                      name="longitude"
                      data={touristSpot}
                      type="number"
                      onKeyDown={(event) => {
                        ["e", "E", "+", ","].includes(event.key) &&
                          event.preventDefault();
                      }}
                    />

                    <TextField
                      size={12}
                      label="Descrição"
                      name="descritivo"
                      data={touristSpot}
                      type="textarea"
                    />

                    <CoverUploadImageField
                      title="Imagens do local"
                      multiple
                      data={touristSpot}
                      name="images"
                    />

                    <Col lg={12}>
                      <div className="text-end">
                        <button type="submit" className="btn btn-primary">
                          Salvar
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </CardBody>
          </Card>
        </Col>
      </div>
      <ModalLoding loading={loading} />
    </React.Fragment>
  );
};

export default TouristSpotForm;
